<template>
  <div class="dynamic-product-list" v-if="dataLoaded" :style="{'margin-left': `${-listCondition.lineGap}px`}">
    <dynamic-product
      :style="defaultStyle"
      v-for="(item, index) in products"
      :key="item.id"
      :data="item"
      :index="index"
      :productCondition="listCondition"
      :miniEnv="miniEnv"
      :productImageHeight="productImageHeight"
      :hideInfoPadding="checkInfoPadding(index)"
      @product-simple="productSimpleJump"
    />
  </div>
</template>

<script>
import dynamicProduct from '@/components/dynamic-product-simple'
import { get } from '@/product'
import { getActivity } from '@/product-activity'
import { lazyload } from '@/lazyload'

export default {
  components: {
    dynamicProduct
  },

  props: {
    dataOrigin: {
      type: String,
      default: 'PRODUCT'
    },
    ids: {
      type: Array,
      default() {
        return []
      },
    },
    listCondition: {
      type: Object,
      default() {
        return {}
      },
    },
    miniEnv: {
      default: false
    },
    originProducts: {
      type: Array,
      default() {
        return []
      },
    },
    listPl: {//仅对部分模块有作用 比如新列表模块
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      productRatio: 330/345,//w/h
      products: null,
      dataLoaded: false,
      productWidth: 0,
      defaultStyle: null,
      productImageHeight: 0
    }
  },

  created () {
    this.formatData()
  },

  methods: {
    formatData () {
      const listCondition = this.listCondition
      console.log(listCondition, "listCondition")
      this.productWidth = (listCondition.listWidth-(listCondition.rowNum-1)*listCondition.lineGap)/listCondition.rowNum
      const productHeight = (this.productWidth/330)*345

      this.productImageHeight = productHeight
      const ratio = this.listCondition.ratio
      const heightObj = {
        imageGap: 10*ratio,
        brandH: 17*ratio,
        productH1: 17*ratio,
        productH2: 34*ratio,
        priceH: 17*ratio
      }
      // let defaultStyle = {
      //   'width': `${this.productWidth}px`,
      //   'height': `${productHeight+imageGap}px`
      // }

      let defaultProductHeight = productHeight+heightObj.imgGap
      if(this.listCondition.brandName === 'SHOW') {
        defaultProductHeight += heightObj.brandH
      }
      if(this.listCondition.productName === 'ONE') {
        defaultProductHeight += heightObj.productH1
      }
      if(this.listCondition.productName === 'TWO') {
        defaultProductHeight += heightObj.productH2
      }
      if(this.listCondition.rawPrice || this.listCondition.nowPrice) {
        defaultProductHeight += heightObj.priceH
      }

      this.defaultStyle = {
        'width': `${this.productWidth}px`,
        'min-height': `${this.defaultProductHeight}px`,
        'margin-bottom': `${this.listCondition.rowGap}px`,
        'margin-left': `${this.listCondition.lineGap}px`
      }

      if(this.originProducts && this.originProducts.length) {
        this.dataLoaded = true
        this.products = this.originProducts
      } else {
        if(this.dataOrigin === 'ACTIVITY') {
          this.getProductsByActivity()
        } else {
          this.getProducts()
        }
      }
    },
    
    getProductsByActivity () {
      this.products = this.ids

      if(!this.ids || this.ids.length === 0) {
        return
      }

      let newIds = []
      this.ids.forEach(id => {
        if(id && !(~newIds.indexOf(id))) {
          newIds.push(id)
        }
      })

      let allArr = []
      let normalArr = []
      let soldOutArr = []
      let offShelfArr = []
      let newProducts = []

      getActivity(newIds, (err, dataMap) => {
        if (err) {
          return
        }
        this.dataLoaded = true

        let products = []
        newIds.forEach((key) => {
          let activity = dataMap[key]
          if(!activity) {
            return
          }
          
          if(activity.products && activity.products.length) {
            products = products.concat(activity.products)
          }
        })

        products.forEach(product => {
          if(!product || product.invisible) {
            return
          }

          if(this.listCondition.soldOutCondition === 'ORIGIN' && !product.offShelf) {
            allArr.push(product)
          } else {
            if(product.offShelf) {
              offShelfArr.push(product)
            } else if(product.soldOut) {
              soldOutArr.push(product)
            } else {
              normalArr.push(product)
            }
          }

        })
        if(this.listCondition.soldOutCondition === 'FILTER') {
          newProducts = normalArr
        } else if(this.listCondition.soldOutCondition === 'ORIGIN') {
          newProducts = allArr
        } else {
          newProducts = normalArr.concat(soldOutArr)
        }

        this.$nextTick(() => {
          this.products = newProducts
          this.$nextTick(() => {
            lazyload()
          })
        })
      })
    },

    getProducts () {
      this.products = this.ids

      if(!this.ids || this.ids.length === 0) {
        return
      }

      let newIds = []
      this.ids.forEach(id => {
        if(id && !(~newIds.indexOf(id))) {
          newIds.push(id)
        }
      })

      let allArr = []
      let normalArr = []
      let soldOutArr = []
      let offShelfArr = []
      let newProducts = []

      get(newIds, (err, productMap) => {
        if (err) {
          return
        }
        this.dataLoaded = true

        newIds.forEach(id => {
          const product = productMap[id]
          if(!product || product.invisible) {
            return
          }
          product.id = id

          if(this.listCondition.soldOutCondition === 'ORIGIN' && !product.offShelf) {
            allArr.push(product)
          } else {
            if(product.offShelf) {
              offShelfArr.push(product)
            } else if(product.soldOut) {
              soldOutArr.push(product)
            } else {
              normalArr.push(product)
            }
          }

        })
        if(this.listCondition.soldOutCondition === 'FILTER') {
          newProducts = normalArr
        } else if(this.listCondition.soldOutCondition === 'ORIGIN') {
          newProducts = allArr
        } else {
          newProducts = normalArr.concat(soldOutArr)
        }

        this.$nextTick(() => {
          this.products = newProducts
          this.$nextTick(() => {
            lazyload()
          })
        })
      })
    },

    checkInfoPadding (index) {
      let hidePadFlag = false
      if(!this.listPl) {//模块没有边距，则不隐藏默认的15边距
        hidePadFlag = false
      } else if(this.listCondition.rowNum === 2 && index%2===0) {//模块有边距，每行的第一个隐藏边距
        hidePadFlag = true
      } else if(this.listCondition.rowNum === 3 && index%3===0) {//模块有边距，每行的第一个隐藏边距
        hidePadFlag = true
      }
      // console.log(this.listPl, index, hidePadFlag)
      return hidePadFlag
    },

    productSimpleJump (product, index) {
      console.log(product, index)
      this.$emit('product-simple', product, index)
    },

  },
}
</script>

 <style lang="stylus">
  @import '../../common/styl/global.styl'
  @import '../../common/styl/grotesk-font.styl'

  .gro-book
    font-family groteskBook
  .gro-demi
    font-family groteskDemi
  .dynamic-product-list
    display flex
    flex-wrap wrap
    // justify-content space-between
      

</style>



// WEBPACK FOOTER //
// index.vue?73c85434